import React, { useEffect } from "react";
import { connect } from "react-redux";
import ReportHealthPage from "./ReportHealth/ReportHealthPage.js";
import { configureReportHealthService } from "../../../../../../../Service/OPSServices/StoreHealthServices/reportHealthService.js";

function ReportHealth(props) {
  const token = props.token;
  if (token) {
    configureReportHealthService({
      getAuthHeader: () => (token.startsWith("Token ") ? token : `Token ${token}`),
    });
  }

  useEffect(() => {
    if (token) {
      configureReportHealthService({
        getAuthHeader: () => (token.startsWith("Token ") ? token : `Token ${token}`),
      });
    }
  }, [token]);

  return (
    <div className="animated fadeIn" style={{ width: "100%", paddingBottom: "30px" }}>
      <ReportHealthPage token={token} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
  };
};

export default connect(mapStateToProps)(ReportHealth);
